import React, { useState } from 'react'
import { TruckIcon } from '@heroicons/react/24/outline'
import Breadcrumb from '@/components/navigation/Breadcrumb'
import { FiltersRow } from './filters/FiltersRow'
import { TableContextProvider } from './table/TableContext'
import { DataTable } from './table/DataTable'
import { getColumns } from './table/Columns'
import { NewPurchaseOrderModal } from './components/NewPurchaseOrderModal'

const PurchaseOrderList: React.FC = () => {
  // Eliminada restricción de entorno de desarrollo
  const [showModal, setShowModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const handleNewPurchaseOrder = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
    setShowEditModal(false)
  }

  const handleCloseEditModal = () => {
    setShowEditModal(false)
  }

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false)
  }

  return (
    <div>
      <Breadcrumb
        icon={<TruckIcon className="h-6 text-gray-500" />}
        paths={[{ name: 'Logística' }, { name: 'Órdenes de compra' }]}
      />
      <FiltersRow />
      <TableContextProvider>
        <DataTable 
          columns={getColumns()} 
          showEditPurchaseOrder={showEditModal}
          showDeletePurchaseOrder={showDeleteModal}
          onClose={handleCloseEditModal}
          onCloseDelete={handleCloseDeleteModal}
          onNewPurchaseOrder={handleNewPurchaseOrder}
        />
      </TableContextProvider>
      
      <NewPurchaseOrderModal
        open={showModal}
        onOpenChange={setShowModal}
      />
    </div>
  )
}

export default PurchaseOrderList
